import { render, staticRenderFns } from "./ToastificationContent.vue?vue&type=template&id=2071e64d&scoped=true"
import script from "./ToastificationContent.vue?vue&type=script&lang=js"
export * from "./ToastificationContent.vue?vue&type=script&lang=js"
import style0 from "./ToastificationContent.vue?vue&type=style&index=0&id=2071e64d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071e64d",
  null
  
)

export default component.exports